document.addEventListener('DOMContentLoaded',()=>{
  const overlay=document.querySelector('[data-hc-menu]');
  const open=document.querySelector('[data-hc-menu-open]');
  const close=document.querySelector('[data-hc-menu-close]');
  const set=(value)=>{
    if(!overlay)return;
    overlay.classList.toggle('open',value);
    overlay.setAttribute('aria-hidden',String(!value));
    open?.setAttribute('aria-expanded',String(value));
    document.documentElement.style.overflow=value?'hidden':'';
    if(value) close?.focus(); else open?.focus();
  };
  open?.addEventListener('click',()=>set(true));
  close?.addEventListener('click',()=>set(false));
  overlay?.addEventListener('click',event=>{if(event.target===overlay)set(false)});
  overlay?.querySelectorAll('a').forEach(link=>link.addEventListener('click',()=>set(false)));
  document.addEventListener('keydown',event=>{if(event.key==='Escape'&&overlay?.classList.contains('open'))set(false)});
});
